import { useParams } from 'react-router-dom'
import ConnectorViewMappingStore, {
  ConnectorViewMappingContext,
} from '../context/context'
import { useContext, useEffect, useState } from 'react'
import { NavContext } from '../../../../context/global_context'
import { getRequest } from '../../../../services/base'
import { getRandomString } from '../../../../utils/common'
import ConnectorImage from '../ConnectorImage'
import { Printer } from '@styled-icons/boxicons-solid'
import ErrorCard from '../../../common/ErrorCard'

const ConnectorMappingPrint = (props) => {
  const { vehicle, connector_view } = useParams()
  const [state, dispatch] = useContext(ConnectorViewMappingContext)
  const [navState, navDispatch] = useContext(NavContext)
  const [status, setStatus] = useState(true)

  useEffect(() => {
    navDispatch({
      type: 'header',
      data: {
        header: 'Admin Tools',
        sub_header: `Vehicle List / ${vehicle} / Vehicle Views / Vehicle View Connector Mapping`,
        id: '',
        show_back_btn: true,
        dtc_details: {},
        vehicle: vehicle,
        back_btn_url: `/vehicles/${vehicle}/connector_views/`,
        full_width_container: true,
      },
    })
    getConnectorViewData()
  }, [])

  const getConnectorViewData = async () => {
    navDispatch({
      type: 'loader',
      data: {
        caption: 'Fetching Connector Views Data',
        showLoader: true,
      },
      notification: {},
    })

    let res = await getRequest(`/api/connector_views/${connector_view}/`)
    if (!res?.status) {
      setStatus(false)
    } else {
      dispatch({
        type: 'connector_view',
        data: { ...res, svg: `${res?.svg}?string=${getRandomString()}` },
      })
      getConnectorsData()
    }
    navDispatch({
      type: 'loader',
      data: {
        caption: '',
        showLoader: false,
      },
      notification: {},
    })
  }

  const getConnectorsData = async (reference, connector, hide_sidebar) => {
    let res = await getRequest(
      `/api/connector_views/connectors/${connector_view}/`
    )
    let tempMappedConnectors =
      res.data?.length > 0 ? res.data?.filter((ctr) => ctr.auto_mapped) : []
    formatMappedReferences(
      tempMappedConnectors,
      reference,
      connector,
      hide_sidebar
    )
  }

  const formatMappedReferences = (data, reference, connector, hide_sidebar) => {
    let tempMappedReferences = {}
    data.map((row, index) => {
      if (row.auto_mapped in tempMappedReferences) {
        tempMappedReferences[row.auto_mapped].push(row.name)
      } else {
        tempMappedReferences[row.auto_mapped] = [row.name]
      }
    })
    if (reference) {
      dispatch({
        type: 'update_mapping_and_reference',
        data: {
          connector: hide_sidebar
            ? {}
            : {
                ...connector,
                auto_mapped: null,
              },
          svg_group_reference: null,
          selected_reference: null,
          connector_view: {
            ...state.connector_view,
            references: reference,
          },
          mappedReferences: tempMappedReferences,
        },
      })
    } else {
      dispatch({ type: 'mappedReferences', data: tempMappedReferences })
    }
  }

  const closePrintBtn = () => {
    if (window.confirm(`Are you sure want to close window?`) === true) {
      window.close()
    }
  }

  const toggleCheckBox = (key) => {
    dispatch({ type: key, data: !state[`${key}`] })
  }

  return (
    <>
      {status ? (
        <>
          <div className="noPrint fixed-button" style={{ marginRight: 16 }}>
            <a
              href="#"
              className="btn mr-2"
              onClick={() => {
                toggleCheckBox('displayConnector')
              }}
            >
              {state.displayConnector ? 'Hide Connectors' : 'Show Connectors'}
            </a>
            <a
              href="#"
              className="btn mr-2"
              onClick={() => {
                document.title = `${state.connector_view?.name}`
                window.print()
              }}
            >
              <Printer size="1.5rem" color="white" /> Print
            </a>
            <a
              className="btn mr-2"
              onClick={() => {
                window.location.reload()
              }}
            >
              Refresh
            </a>
            <a
              className="btn"
              onClick={() => {
                closePrintBtn()
              }}
            >
              Close
            </a>
          </div>
          <div
            className="flex flex-grow stretch-items overflow-hidden"
            style={{ height: '100vh' }}
          >
            <ConnectorImage isPrint={true} />
          </div>
        </>
      ) : (
        <ErrorCard title={'Not Found'} sub_title={'Data Not Found 404!'} />
      )}
    </>
  )
}

const ConnectorViewMappingPrint = () => {
  return (
    <ConnectorViewMappingStore>
      <ConnectorMappingPrint />
    </ConnectorViewMappingStore>
  )
}

export default ConnectorViewMappingPrint
